export default __webpack_public_path__ + "static/media/Floorplan.bdca1ea7.svg";